// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XTcZ","left":"styles_left__2Q9pp","right":"styles_right__1PfGz","alert":"styles_alert__3kHiP"};